function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M53.7301 5.32091L56.4272 10.1471L53.73 14.9732L50.9606 19.7501L45.5 19.7941L40.0394 19.7501L37.27 14.9732L34.5728 10.1471L37.27 5.32083L40.0394 0.54404L45.5 0.500016L50.9606 0.54404L53.7301 5.32091Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M53.7301 85.3209L56.4272 90.1471L53.73 94.9732L50.9606 99.7501L45.5 99.7941L40.0394 99.7501L37.27 94.9732L34.5728 90.1471L37.27 85.3208L40.0394 80.544L45.5 80.5L50.9606 80.544L53.7301 85.3209Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M87.7301 65.3209L90.4272 70.1471L87.73 74.9732L84.9606 79.7501L79.5 79.7941L74.0394 79.7501L71.27 74.9732L68.5728 70.1471L71.27 65.3208L74.0394 60.544L79.5 60.5L84.9606 60.544L87.7301 65.3209Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.7301 65.3209L22.4272 70.1471L19.73 74.9732L16.9606 79.7501L11.5 79.7941L6.03942 79.7501L3.26995 74.9732L0.572786 70.1471L3.27 65.3208L6.03942 60.544L11.5 60.5L16.9606 60.544L19.7301 65.3209Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M70.7301 75.3209L73.4272 80.1471L70.73 84.9732L67.9606 89.7501L62.5 89.7941L57.0394 89.7501L54.27 84.9732L51.5728 80.1471L54.27 75.3208L57.0394 70.544L62.5 70.5L67.9606 70.544L70.7301 75.3209Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M36.7301 75.3209L39.4272 80.1471L36.73 84.9732L33.9606 89.7501L28.5 89.7941L23.0394 89.7501L20.27 84.9732L17.5728 80.1471L20.27 75.3208L23.0394 70.544L28.5 70.5L33.9606 70.544L36.7301 75.3209Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M87.7301 45.3209L90.4272 50.1471L87.73 54.9732L84.9606 59.7501L79.5 59.7941L74.0394 59.7501L71.27 54.9732L68.5728 50.1471L71.27 45.3208L74.0394 40.544L79.5 40.5L84.9606 40.544L87.7301 45.3209Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M19.7301 45.3209L22.4272 50.1471L19.73 54.9732L16.9606 59.7501L11.5 59.7941L6.03942 59.7501L3.26995 54.9732L0.572786 50.1471L3.27 45.3208L6.03942 40.544L11.5 40.5L16.9606 40.544L19.7301 45.3209Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M70.7301 15.3209L73.4272 20.1471L70.73 24.9732L67.9606 29.7501L62.5 29.7941L57.0394 29.7501L54.27 24.9732L51.5728 20.1471L54.27 15.3208L57.0394 10.544L62.5 10.5L67.9606 10.544L70.7301 15.3209Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M87.7301 25.3209L90.4272 30.1471L87.73 34.9732L84.9606 39.7501L79.5 39.7941L74.0394 39.7501L71.27 34.9732L68.5728 30.1471L71.27 25.3208L74.0394 20.544L79.5 20.5L84.9606 20.544L87.7301 25.3209Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M19.7301 25.3209L22.4272 30.1471L19.73 34.9732L16.9606 39.7501L11.5 39.7941L6.03942 39.7501L3.26995 34.9732L0.572786 30.1471L3.27 25.3208L6.03942 20.544L11.5 20.5L16.9606 20.544L19.7301 25.3209Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M36.7301 15.3209L39.4272 20.1471L36.73 24.9732L33.9606 29.7501L28.5 29.7941L23.0394 29.7501L20.27 24.9732L17.5728 20.1471L20.27 15.3208L23.0394 10.544L28.5 10.5L33.9606 10.544L36.7301 15.3209Z"
});

function SvgRing2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 101,
    viewBox: "0 0 91 101",
    fill: "white",
    stroke: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing2);
export default __webpack_public_path__ + "static/media/Ring2.f82b682d.svg";
export { ForwardRef as ReactComponent };